import {infiniteQueryOptions, keepPreviousData} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {SavedMealsDependencies} from '../dependencies';
import {keys} from './keys';

export type ListSavedMealsQueryDependencies = Pick<SavedMealsDependencies, 'controllers'>;

export const listSavedMealsQuery = ({controllers}: ListSavedMealsQueryDependencies, q: string) =>
  infiniteQueryOptions({
    queryKey: keys.list(q),
    queryFn: ({pageParam}) =>
      controllers.savedMealController.list({cursor: pageParam, q}).then(unwrap),
    initialPageParam: null as string | null,
    getNextPageParam: lastPage => lastPage.nextCursor ?? undefined,
    placeholderData: keepPreviousData,
  });
